import { Spinner } from '@components/spinner/Spinner';
import { PermissionSuperAdminRead } from '@constants/permissions';
import { MainLayout, PublicLayout } from '@layouts';
import { Routes as RouteList } from '@models/route';
import { PrivateRoute, SignedOutPage } from '@swyft/auth';
import { MainLayoutProvider } from '@swyft/ui';
import { flattenRoutes } from '@utils/routes';
import * as React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { ClientRoutes } from './Clients';
import { EngineerRoutes } from './Engineers';
import { GalleryRouter } from './Gallery';
import { ServiceRoutes } from './Services';
import { SwyftRoutes } from './Swyft';
import { TenantRoutes } from './Tenants';
import { UserRoutes } from './Users';

const mainRoutes: RouteList = flattenRoutes([
  ...ClientRoutes,
  ...UserRoutes,
  ...TenantRoutes,
  ...ServiceRoutes,
  ...GalleryRouter,
  ...EngineerRoutes,
  ...SwyftRoutes
]);
const publicRoutes: RouteList = flattenRoutes([]);

export const AppRoutes = (): React.ReactElement => {
  return (
    <BrowserRouter>
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <MainLayoutProvider>
          <Routes>
            <Route
              path='/signout-redirect'
              element={() => <SignedOutPage name='Pipelyne Admin Portal' redirectPath='/' />}
            />
            <Route path='/' element={() => <Navigate to='/clients' />} />
            {mainRoutes
              .filter(({ component }) => component)
              .map(({ path, component: Component }) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    <PrivateRoute permission={PermissionSuperAdminRead}>
                      <MainLayout>
                        <React.Suspense fallback={<Spinner />}>
                          <Component />
                        </React.Suspense>
                      </MainLayout>
                    </PrivateRoute>
                  }
                />
              ))}
            {publicRoutes
              .filter((r) => r.component)
              .map((r) => (
                <Route
                  element={
                    <PublicLayout>
                      <React.Suspense fallback={<Spinner />}>
                        <r.component />
                      </React.Suspense>
                    </PublicLayout>
                  }
                  path={r.path}
                  key={r.path}
                />
              ))}
          </Routes>
        </MainLayoutProvider>
      </QueryParamProvider>
    </BrowserRouter>
  );
};
